import QRCode from 'qrcode'
import moment from "moment";
import Constant from "./Constants";
import { find } from 'lodash';
import i18n from 'i18n';
import RollbarConfig from "utils/RollbarConfig";

/**
 * Get days in the next two week
 */
export function getDaysArray() {
  let now = new Date();
  let endDate = new Date(new Date().setDate(now.getDate() + 13));
  let idx = 0;
  let arrFirstWeek = [];
  let arrSecondWeek = [];
  for (let dt = now; dt <= new Date(endDate); dt.setDate(dt.getDate() + 1)) {
    idx = idx + 1;
    let tmpDate = new Date(dt).toISOString().slice(0, 10);
    if (idx < 8) {
      arrFirstWeek.push(tmpDate);
    } else {
      arrSecondWeek.push(tmpDate);
    }
  }

  return { firstWeek: arrFirstWeek, secondWeek: arrSecondWeek };
}

export const copyToClipboard = async (url) => {
  try {
    await navigator.clipboard.writeText(url)

    return true;
  } catch(error) {

    RollbarConfig.error(`Failed copy to clipboard`, {
      'textOrigin': url,
      'errorMessage': error,
      'device': navigator?.userAgentData
    })

    console.log('Error copy ', error)
    return false;
  }
}

export function readURL(input) {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader.onload = function (e) {
      resolve(e.target.result)
    }

    reader.readAsDataURL(input.target.files[0]);

  })
}

export const displayTypeCourseFromService = (type) => {
  if (type === Constant.categoryCourseValueFromService.ELEARNING) {
    return "E-Learning"
  }
  if (type === Constant.categoryCourseValueFromService.VIRTUAL) {
    return "Virtual"
  }
  if (type === Constant.categoryCourseValueFromService.OFFLINE) {
    return "Offline"
  }
  return ""
}

export const detectNumberChange = (val, max = Constant.maxNumber, min = 0) => {
  var reg = /^\d+/;
  let changedValue = 0
  if (reg.test(val)) {
    if (val <= 0) changedValue = 0
    else if (val > max) changedValue = max
    else changedValue = parseInt(val)
  } else {
    changedValue = ''
  }

  return changedValue
}

export const countTotalGeneratedQuestion = (items = [], key = "totalGeneratedQuestion") => {
  return items?.reduce((acc, item) => parseInt(acc) + parseInt(item[key] || 0), 0)
}

export const showMediaInput = {
  upload: (mediaType) => [
    Constant.mediaTypeRepo.pdf,
    Constant.mediaTypeRepo.ppt,
    Constant.mediaTypeRepo.audio,
    Constant.mediaTypeRepo.videoInternal].indexOf(mediaType) > -1,
  uploadImage: (mediaType) => [Constant.mediaTypeRepo.image].indexOf(mediaType) > -1,
  uploadFolder: (mediaType) => [Constant.mediaTypeRepo.interactive].indexOf(mediaType) > -1,
  text: (mediaType) => [Constant.mediaTypeRepo.link, Constant.mediaTypeRepo.videoExternal].indexOf(mediaType) > -1,
}

export const showDownloadCondition = (mediaType) => {
  return [
    Constant.mediaTypeRepo.pdf,
    Constant.mediaTypeRepo.ppt,
    Constant.mediaTypeRepo.audio,
    Constant.mediaTypeRepo.videoInternal,
    Constant.mediaTypeRepo.image,
    Constant.mediaTypeRepo.videoExternal,
    Constant.mediaTypeRepo.link
  ].indexOf(mediaType) > -1
}

export const showDownloadConditionCheckbox = (mediaType) => {
  return [
    Constant.mediaTypeRepo.pdf,
    Constant.mediaTypeRepo.ppt,
    Constant.mediaTypeRepo.audio,
    Constant.mediaTypeRepo.videoInternal,
    Constant.mediaTypeRepo.image
  ].indexOf(mediaType) > -1
}

/**
 * 
 * @param {UISmileAssessments[]} assessments 
 * @returns {UpdateSmileCertificationPayload.SmileProgram[]}
 */
export const buildSmileProgramPayload = (assessments) => {
  let programsHashMap = {}
  assessments.forEach((item) => {
    let { uiProgramId } = item
    let hashMapChecker = programsHashMap[`${uiProgramId}`] !== null && programsHashMap[`${uiProgramId}`] !== undefined
    if (!hashMapChecker) {
      programsHashMap[`${uiProgramId}`] = {
        programId: uiProgramId,
        lstSmileAssessmentDtoList: []
      }
    }

    let { assessmentDuration, assessmentHasRepeat, assessmentMinScore, assessmentRepeatHasLimit, assessmentRepeatMax, chapterDescription, chapterName, questionBankProgramId } = item
    let assessmentQuestions = item?.questionBankCategories?.map((question) => ({
      questionCategoryId: question?.id,
      totalGeneratedQuestion: question?.generatedQuestion
    }))

    /**
     * @type {UpdateSmileCertificationPayload.SmileProgram.Assessment}
     */
    let singleAssessment = {
      assessmentDuration,
      assessmentHasRepeat,
      assessmentMinScore,
      assessmentRepeatHasLimit,
      assessmentRepeatMax,
      chapterDescription,
      chapterName,
      questionBankProgramId,
      lstSmileAssessmentQuestionDtoList: assessmentQuestions
    }

    let newProgramAssessments = [...programsHashMap[`${uiProgramId}`][`lstSmileAssessmentDtoList`]]
    newProgramAssessments.push(singleAssessment)
    programsHashMap[`${uiProgramId}`]['lstSmileAssessmentDtoList'] = newProgramAssessments
  })

  /**
   * @type {UpdateSmileCertificationPayload.SmileProgram[]}
   */
  let returnPrograms = []
  for (let key in programsHashMap) {
    returnPrograms?.push({
      programId: parseInt(key),
      id: programsHashMap[key]['smileProgramId'],
      smileId: programsHashMap[key]['smileId'],
      lstSmileAssessmentDtoList: programsHashMap[key]['lstSmileAssessmentDtoList']
    })
  }

  return returnPrograms
}

/**
* 
* @param {UISmileAssessments[]} assessments 
* @returns {UpdateSmileCertificationPayload.SmileProgram[]}
*/
export const buildUpdateSmileProgramPayload = (assessments) => {
  let programsHashMap = {}
  assessments.forEach((item) => {
    let { uiProgramId, smileProgramId: programSmileId, smileId } = item
    let hashMapChecker = programsHashMap[`${uiProgramId}`] !== null && programsHashMap[`${uiProgramId}`] !== undefined
    if (!hashMapChecker) {
      programsHashMap[`${uiProgramId}`] = {
        programId: uiProgramId,
        smileProgramId: programSmileId,
        smileId,
        lstSmileAssessmentDtoList: []
      }
    }

    let { assessmentDuration, assessmentHasRepeat, assessmentMinScore,
      assessmentRepeatHasLimit, assessmentRepeatMax, chapterDescription,
      chapterName, questionBankProgramId,
      id, smileProgramId } = item

    let assessmentQuestions = item?.questionBankCategories?.map((question) => {
      if (question?.smileAssessmentId) return {
        id: question?.id,
        smileAssessmentId: question?.smileAssessmentId,
        questionCategoryId: question?.questionCategoryId,
        totalGeneratedQuestion: question?.generatedQuestion
      }

      return {
        questionCategoryId: question?.id,
        totalGeneratedQuestion: question?.generatedQuestion
      }
    })

    /**
     * @type {UpdateSmileCertificationPayload.SmileProgram.Assessment}
     */
    let singleAssessment = {
      id,
      smileProgramId,
      assessmentDuration,
      assessmentHasRepeat,
      assessmentMinScore,
      assessmentRepeatHasLimit,
      assessmentRepeatMax,
      chapterDescription,
      chapterName,
      questionBankProgramId,
      lstSmileAssessmentQuestionDtoList: assessmentQuestions
    }

    let newProgramAssessments = [...programsHashMap[`${uiProgramId}`][`lstSmileAssessmentDtoList`]]
    newProgramAssessments.push(singleAssessment)
    programsHashMap[`${uiProgramId}`]['lstSmileAssessmentDtoList'] = newProgramAssessments
  })

  /**
   * @type {UpdateSmileCertificationPayload.SmileProgram[]}
   */
  let returnPrograms = []
  for (let key in programsHashMap) {
    returnPrograms?.push({
      programId: parseInt(key),
      id: programsHashMap[key]['smileProgramId'],
      smileId: programsHashMap[key]['smileId'],
      lstSmileAssessmentDtoList: programsHashMap[key]['lstSmileAssessmentDtoList']
    })
  }

  return returnPrograms
}

/**
 * 
 * @param {Date} start 
 * @param {Date} end 
 * @returns {Boolean}
 */
export const isEndDateValid = (start, end) => {
  const startMillis = moment(start).startOf('date').valueOf()
  const endMillis = moment(end).startOf('date').valueOf()

  return endMillis >= startMillis
}

export const renderHighlightStatus = (highlightStatus) => {
  if (highlightStatus === Constant.highlightStatus.HIGHLIGHTCHECK) return Constant.highlightStatus.HIGHLIGHTLABEL
  else if (highlightStatus === Constant.highlightStatus.UNHIGHLIGHTCHECK) return Constant.highlightStatus.UNHIGHLIGHTLABEL

  return Constant.highlightStatus.NOTDEFINED
}

export const isDateBetweenCourse = (checkDate, start, end) => {
  return moment(checkDate).isBetween(moment(start), moment(end), undefined, '[]')
}

export const remapSummaryCourseTrainer = (origin = []) => {
  origin.push({
    countStatus: origin.reduce((current, prev) => current + prev.countStatus, 0),
    status: 'total'
  })

  return origin
}

export function getBase64Image(src) {
  return new Promise((resolve, reject) => {
    var img = new Image();
    img.crossOrigin = 'Anonymous';
    img.onload = function() {
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      var dataURL;
      canvas.height = this.naturalHeight;
      canvas.width = this.naturalWidth;
      ctx.drawImage(this, 0, 0);
      dataURL = canvas.toDataURL('image/png');
      resolve(dataURL);
    };
    img.src = src;
    if (img.complete || img.complete === undefined) {
      img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
      img.src = src;
    }
  })
}

export function toDataURL(url) {
  return new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        resolve(reader.result.replace('text/html', 'image/jpeg'))
      }
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  })
}

/**
 * 
 * @param {array} trainerList merge from listTrainerDto object
 */
export const mergeTrainerListToString = (trainerList = []) => {
  return trainerList.map(_row => _row?.lstUserDto?.name).join(', ')
}


export const generateUrlForRecordAttendance = (courseId, batchId, scheduleId) => {
  let _host = window.location.origin;
  return `${_host}/app-redirect?pageId=student-attendance&cid=${courseId}&bid=${batchId}&sid=${scheduleId}`
}

export const generateBase64QrCode = async (text) => {
  let base64 = await QRCode.toDataURL(text, { width: 800, height: 800, margin: 1 })
  return base64;
}

export const isRequiredString = (t, i18nField) => {
  return `${t(i18nField)} ${t('common.isRequired')}`
}


export const validateCertificateTemplatePlaceholder = (template) => {

  if (template == null) return { status: false, type: 'empty-content' }

  const regex = /\[([^\][]*)]/g;
  const array = template.match(regex);
  const columns = Constant.certificatePlaceholder.map(row => row.toLowerCase());

  if (!array || array == null) return { status: false, type: 'no_placeholder' }

  for (let field of array) {
    let parseField = field.replaceAll(/[\[\]]/gi, '').toLowerCase();
    if (columns.indexOf(parseField) < 0) {
      return {
        status: false,
        type: 'error_field',
        field
      }
    }
  }

  return { status: true, message: '' }
}

export function isBase64(str) {
  if(!str || typeof str !== 'string') return false;
  return str.indexOf('data:image/') >= 0 && str.indexOf(';base64') >= 0;
}

export function remapSavedAnswerQuestion(mstQuestionDtoList) {
    let _savedAnswer = {}
    mstQuestionDtoList?.map((question, index) => {
      if(question?.mstQuestionAnswerDtoList[0].answerId !== null) {
        _savedAnswer[index] = {
          questionId: question?.id,
          answerId: question?.mstQuestionAnswerDtoList[0].answerId
        }
      }
    })
    
    return _savedAnswer
}

export function remapSavedAnswerQuestionChapter(mstQuestionDtoList) {
  let _savedAnswer = {}
  mstQuestionDtoList?.forEach((question, index) => {
    if(question?.answer !== "") {
      const _fdata = find(question?.mstQuestionAnswerDtoList, (_row) => _row.id.toString() === question?.answer)
      _savedAnswer[index] = {
          questionId: _fdata?.mstQuestionId,
          answerId: _fdata?.answerId
      }
    }
  })
  
  return _savedAnswer
}

export function isQuestionHasAnswered(savedAnswer, index) {
  return Object.keys(savedAnswer).indexOf(index.toString() >= 0) && typeof savedAnswer[index]?.answerId !== 'undefined'
}

export function getQuestionHasAnswered(savedAnswer) {
  const _filter = [];
  Object.keys(savedAnswer).forEach((_index) => {
    if(savedAnswer[_index]?.answerId !== null && typeof savedAnswer[_index]?.answerId !== 'undefined') _filter.push(_index) 
  })

  return _filter;
}


export function dateAddMinute(minute) {
  return moment().add(minute, 'm').toDate()
}

export function toCurrencyFormat(number){

  if(!number ) return 0;
  
  var number_string = number.toString().replace(/[^,\d]/g, '').toString(),
  split   		= number_string.split(','),
  sisa     		= split[0].length % 3,
  rupiah     		= split[0].substr(0, sisa),
  ribuan     		= split[0].substr(sisa).match(/\d{3}/gi);

  if(ribuan){
    let separator = sisa ? '.' : '';
    rupiah += separator + ribuan.join('.');
  }

  return split[1] !== undefined ? rupiah + ',' + split[1] : rupiah;
}

export function readableCurrency(number) {

  if(!number) return 0;

  const {t} = i18n
  var floor=Math.floor, abs=Math.abs, log=Math.log, round=Math.round, min=Math.min;
  var abbrev = [ t('currency.thousand'), t('currency.million'), t('currency.billion')]; // abbreviations in steps of 1000x; extensible if need to edit
  
  function rnd(n, precision) {
      var prec = 10**precision;
      return round(n*prec)/prec;
  }
  
  function format(n) {
      var base = floor(log(abs(n))/log(1000));
      var suffix = abbrev[min(abbrev.length-1, base-1)];
      base = abbrev.indexOf(suffix) + 1;
      return suffix ? rnd(n/1000**base,2)+ ' ' +suffix : ''+n;
  }

  return format(number);
}


export function isCopySupported(action = ['copy']) {
  const actions = typeof action === 'string' ? [action] : action;
  let support = !!document.queryCommandSupported;

  actions.forEach((action) => {
    support = support && !!document.queryCommandSupported(action);
  });

  return support;
}

export function excerpt(description='', length=20) {
  let words = description.split(' ')
  
  if(words?.length <= length) return description 

  return words.slice(0, length).join(' ') + '...';
}

export function truncateTitle(title='', length=55) {
  if(title.length < length) return title;
  return `${title.slice(0, length)}...`
}

export function isSmileFailed(allDoneTest=[]) {
    let _index = allDoneTest?.findIndex((item) => item?.isPassTest === false )
    return _index >= 0;
}

export function validateFromObject(objectToValidate) {
  for( const field in objectToValidate ) {
    if(objectToValidate[field] === false) {
      return {
        isValid: false,
        field
      };
    }
  }
  
  return {
    isValid: true
  }
}

export function convertToBr(string) {

  if (typeof string === 'string') {
    return string?.replace(/\r?\n|\r/g, '<br>')
  }

  return string;
  
}

/**
 * Used in admin, mark selected users in user list
 * Mainly use in ModalAddUsersToCourse.js
 */
export function markSelectedUsers(userList=[], selectedIds=[], disabled=false) {
  return userList?.map((_user) => {
      if(selectedIds.indexOf(_user?.id) >= 0) return {..._user, checked: true, disabled: disabled}
      return _user
  })
}


export function getHighlighted(courses=[]) {

  let higlightCourses = courses.filter((_row) => _row.isHighlight === true && _row.status.toLowerCase() !== Constant.courseStatus.COMPLETED ).sort((a,b) => moment(a.periodTo).format('YYYYMMDD') - moment(b.periodTo).format('YYYYMMDD'));
  
  if(higlightCourses.length <= 0) return false;
  return higlightCourses[0];
}

export function scrollToElement(queryElement, offsetTop=0) {
  let posTop = queryElement.getBoundingClientRect().top + window.scrollY - offsetTop;
  window.scrollTo(0, posTop);
}
